import { ReactNode } from 'react';
import clsx from 'clsx';

type ContainerProps = {
  children?: ReactNode;
  className?: string;
  id?: string;
};

export function Container({ children, className, id = '' }: ContainerProps) {
  return (
    <div id={id} className={clsx('mx-auto max-w-full px-[16px] md:w-[1200px] md:px-0', className)}>
      {children}
    </div>
  );
}

export function ContainerWithGround({
  children,
  contentClass,
  className,
  extendsNode,
  id = '',
}: ContainerProps & { contentClass?: string; extendsNode?: ReactNode }) {
  return (
    <div id={id} className={className}>
      {extendsNode}
      <Container className={contentClass}>{children}</Container>
    </div>
  );
}
